import { Context, Text, styled } from '@obvio/app'
import { notDesktop } from '@obvio/app'
import { SvgSeeGrid, SvgSeeList } from '@obvio/svg'
import { ProductsGrid2, SortFilterBar } from '@obvio/template'
import { Section, Stack } from '@obvio/ui'
import { useState } from 'react'

import { FiltersModal } from './FiltersModal'
import { ProductsGridTest } from './ProductsGridTest'
import { ProductTile } from './StorePage/ProductTile'
import { Cursor } from '../Cursor'
import { Layout } from '../Layout'
import { TextSection } from '../TextSection'

import type { ReactElement } from 'react'

const BarStack = styled(Stack)`
  align-items: baseline;
`

const SeeStack = styled(Stack)`
  align-items: center;
  @media ${notDesktop} {
    display: none;
  }
`

const SwitchButton = styled.div<{ $active: boolean }>`
  cursor: pointer;
  color: ${(theme, { $active }) =>
    $active ? theme.colors.primary : theme.colors.additional[0]};
`
const Divider = styled.div`
  height: 1rem;
  width: 1px;
  background-color: ${(theme) => theme.colors.primary};
`

export const PRODUCT_SELECT = {
  id: true,
  title: true,
  images: true,
  merchant: {
    id: true,
    name: true,
  },
  slug: true,
  year: true,
  price: {
    price: true,
    lowestPriceBeforeSale: true,
    regularPrice: true,
    currency: true,
    otherPrices: true,
  },
} as const

export function StorePage(): ReactElement {
  const [filtersOpen, setFiltersOpen] = useState(false)
  const [view, setView] = useState<2 | 3>(3)
  return (
    <>
      <Context name="withGrid">
        <Cursor kind="black" />
        <Layout context="store">
          <TextSection>
            <Text tag="h1" as="h2">
              Shop Artworks
            </Text>
          </TextSection>
          <Section>
            <BarStack spacing="extraSmall">
              <SeeStack spacing="extraSmall">
                <Text tag="span">SEE</Text>
                <SwitchButton $active={view === 2} onClick={() => setView(2)}>
                  <SvgSeeList width="1rem" height="1rem" />
                </SwitchButton>
                <Divider />
                <SwitchButton $active={view === 3} onClick={() => setView(3)}>
                  <SvgSeeGrid width="1rem" height="1rem" />
                </SwitchButton>
              </SeeStack>
              <SortFilterBar
                onFilter={() => setFiltersOpen(true)}
                sortProps={{
                  customSorters: [
                    {
                      by: 'year',
                      order: 'desc',
                      title: 'Artwork year (desc.)',
                    },
                    { by: 'year', order: 'asc', title: 'Artwork year (asc.)' },
                  ],
                }}
              />
            </BarStack>
          </Section>
          {view === 2 ? (
            <ProductsGrid2
              selectExtend={PRODUCT_SELECT}
              productTile={ProductTile}
              defaultSort={{ by: 'orderIndex', order: 'asc' }}
            />
          ) : (
            <ProductsGridTest />
          )}
        </Layout>
      </Context>
      <Context name="store">
        <FiltersModal
          open={filtersOpen}
          onClose={() => setFiltersOpen(false)}
        />
      </Context>
    </>
  )
}
